/**
 * Configuration for analytics and feedback features
 */

import { envConfig } from './env.config';

/**
 * Analytics configuration
 */
export const analyticsConfig = {
  /**
   * Umami Analytics configuration
   */
  umami: {
    // Your Umami instance URL (from environment variables)
    baseUrl: envConfig.analytics.umami.baseUrl,
    
    // Your website ID from Umami dashboard (from environment variables)
    websiteId: envConfig.analytics.umami.websiteId,
    
    // Whether to track events in development mode
    trackInDevelopment: envConfig.analytics.umami.trackInDevelopment,
    
    // Whether analytics is enabled
    enabled: envConfig.analytics.umami.enabled,
    
    // Custom events to track
    customEvents: [
      'feedback_submitted',
      'feedback_form_opened',
      'export',
      'time_entry_action',
      'project_action',
      'feature_used'
    ]
  },
  
  /**
   * Formspree configuration for feedback form
   */
  formspree: {
    endpoint: envConfig.feedback.formspree.endpoint,
    enabled: envConfig.feedback.formspree.enabled,
    
    // Whether to show success message after submission
    showSuccessMessage: true,
    
    // Email to receive notifications (optional, handled by Formspree)
    notificationEmail: ''
  }
};

// Re-export getEnvironmentConfig for backward compatibility
export { getEnvironmentConfig } from './env.config';
